import axios from 'axios'
import qs from 'qs'
import state from './state'

function members(data) {
  if (!state.apiURL) {
    return Promise.reject(new Error('Cannot find API server.'))
  }
  return axios.get(state.apiURL + '/api/members?' + qs.stringify(data))
}

function location(data) {
  if (!state.apiURL) {
    return Promise.reject(new Error('Cannot find API server.'))
  }
  return axios.get(state.apiURL + '/api/location?' + qs.stringify(data))
}

function contact(data) {
  if (!state.apiURL) {
    return Promise.reject(new Error('Cannot find API server.'))
  }
  return axios.post(state.apiURL + '/api/contact', data)
}

function call(data) {
  if (!state.apiURL) {
    return Promise.reject(new Error('Cannot find API server.'))
  }
  return axios.post(state.apiURL + '/api/call', data)
}

export default { members, location, contact, call }



// WEBPACK FOOTER //
// ./src/api-client.js